import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import React, { useState, useEffect } from 'react';

import CartItem from '../modules/CardCartItem';


import { Search} from 'react-bootstrap-icons';

import CheckoutForm from '../forms/Checkout';
import { GetHeaders, PostDataFetch } from '../../hooks/DataFetch';
import GenericFormContainer from '../forms/FormContainer';
import { INTRFUser, INTRFItem } from '../../hooks/Interfaces';
import ImageContainer from '../blocks/UIImageContainer';


import { useNavigate } from 'react-router-dom';

interface ApplicationProps {
    user: INTRFUser;
    updatefunc: () => void;
}
interface PriceAdjustmentProps {
    name: string;
    discount: boolean;
    percentage: boolean;
    rate: number;

}
interface CartItemProps {
    inventory_id: string;
    name: string;
    price: number;
    quantity: number;
    total: number;
}

function SearchPage({user, updatefunc}: ApplicationProps){
    
    /* For UI  */
    const [inventory, setInventory] = useState<INTRFItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [searched, setSearched] = useState(false);

    /* For UI API */
    const [search_string, setSearchString] = useState('');
    
    /** Config */
    let axiosConfig = GetHeaders();
    const posturl = process.env.REACT_APP_API_URL + "/v1/catalogue/inventory";

    const filterinfo = {
        search_string,
    };


    // 1. Initialize the navigate function
    const NavigateToPage = (url: string) => {
        window.location.href = "/inventory/item/" + url;
    };


    const HandleSubmit = async (event: React.SubmitEvent) => {
        event.preventDefault(); 
        GetInventory();
    }

    const GetInventory = async () => {
        setLoading(true);
        let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: filterinfo})
        //Handle a Non 200 response
        setInventory(response.items)
        console.log(response.items)
        setLoading(false);
        setSearched(true);
    }

    /* Component Init */
    useEffect(() => {
        console.log("Initializing cart component.")
        /*GetInventory();*/

    }, [inventory]);

    return (
        <> 
            <Container id="search-overlay" className="pt-5">
                <form onSubmit={HandleSubmit}>
                    <Row className="brand-tertiary-color-border-full py-2 rounded-pill bg-white">
                        <Col xs={{span:11}}>
                            <input id="search_string" type="text" placeholder="Search" className="input-fill border-0 no-generic-input-styles" onChange={(e) => {setSearchString(e.target.value)}} />
                        </Col>
                        <Col xs={{span:1}}>
                            <Search />
                        </Col>
                        
                    </Row>
                </form>

                { inventory.map( (item, index)  => 
                    <Row key={item.itemid} className="result p-2 rounded-pill my-1" onClick={() => NavigateToPage(item.itemid)}>
                        <Col xs={{span: 3}}><ImageContainer img_url={item.image} />{}</Col>
                        <Col xs={{span: 6}} className="text-start text-font-size-small text-font-body">{item.name} </Col>
                        <Col xs={{span: 3}} className="text-start text-font-size-small text-font-body">${item.price.toFixed(2)}</Col>
                    </Row>)
                }
                { (inventory.length < 1) && searched &&
                    <Row>
                        <Col>
                        <p className="text-font-size-large text-font-body text-font-heavy">No results..</p>
                        </Col>
                    </Row>
                
                }


            </Container>
                 
                

                

        </>
    )
}

export default SearchPage;